// src/components/PostList/index.js

import React from "react";
import "./style.css";

function PostList() {
    return (
        <div className="blog-container">
            <header>
                <h1>Gideon's Blog</h1>
            </header>

            <section className="content">
                <p>I am in the process of migrating my blog archive here. Coming soon.</p>
            </section>

            <div className="nav">
                <a href="/">← Back to Home</a>
            </div>
        </div>
    );
}

export default PostList;